import React from 'react';
import TournamentManagementPage from '@/pages/admin/TournamentManagementPage';

const DEMO_EVENT_ID = 'f83c2769-b4aa-4ba9-9e3e-5e205fd40047';

const DemoTournaments: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Tournament Management Demo</h1>
        <p className="text-gray-600">Create brackets, schedule matches, and manage tournament flow</p>
      </div>
      <TournamentManagementPage />
    </div>
  );
};

export default DemoTournaments;
